export default "__VITE_ASSET__Cd74SmP4__"